import { render, staticRenderFns } from "./allTask.vue?vue&type=template&id=151a78a2&scoped=true&"
import script from "./allTask.vue?vue&type=script&lang=js&"
export * from "./allTask.vue?vue&type=script&lang=js&"
import style0 from "./allTask.vue?vue&type=style&index=0&lang=css&"
import style1 from "./allTask.vue?vue&type=style&index=1&id=151a78a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a78a2",
  null
  
)

export default component.exports